import { render } from "./CustomInput.vue?vue&type=template&id=38ecb662&scoped=true&ts=true"
import script from "./CustomInput.vue?vue&type=script&lang=ts"
export * from "./CustomInput.vue?vue&type=script&lang=ts"

import "./CustomInput.vue?vue&type=style&index=0&id=38ecb662&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ecb662"]])

export default __exports__